export default __webpack_public_path__ + "static/azlinda-2ee4610cf9e7a16e8f74158a163b1ed5.jpg";